<template>
  <FormSubmitPopup
    :title="$t('resolveCase')"
    @popupClose="$emit('input', false)"
    v-model="value"
    :rightMethod="onSubmitted"
    :rightButtonText="$t('submit')"
    medium
  >
    <template v-slot:input>
      <v-container>
        <v-layout row wrap align-baseline>
          <v-flex xs12 sm6>
            <v-combobox
              :label="$t('resolution')"
              multiple
              chips
              class="required_field"
              :items="types"
              v-model="resolveTypes"
              :rules="[fieldIsRequired('resolve type')]"
            ></v-combobox>
          </v-flex>
          <v-flex xs12 md6 style="position: relative; top: 5px;">
            <v-text-field
              :label="$t('amount')"
              :rules="[fieldIsRequired('Amount'), fieldIsNumber('amount')]"
              v-model.number="amount"
              class="required_field"
              :hint="$t('caseAmountHint')"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        
        <v-textarea
          outline
          :label="$t('details')"
          :counter="500"
          auto-grow
          rows="3"
          v-model="details"
        ></v-textarea>

        <v-text-field
          :label="$t('keywords')"
          v-model="keywords"></v-text-field>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import {checkRules} from '@/utils/tools'

export default {
  name: 'SupportResolvePopup',
  components: {
    FormSubmitPopup
  },
  mixins: [checkRules],
  data () {
    return {
      types: ['Reimburse', 'Fix data', 'No ops', 'Others'],
      details: '',
      resolveTypes: [],
      amount: 0,
      keywords: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.applyDefaultAmount()
        }
      }
    },
    defaultAmount () {
      if (this.value) {
        this.applyDefaultAmount()
      }
    }
  },
  methods: {
    applyDefaultAmount () {
      const parsedAmount = Number(this.defaultAmount)
      this.amount = Number.isFinite(parsedAmount) ? parsedAmount : 0
    },
    onSubmitted () {
      const {details, resolveTypes, amount, keywords} = this
      const payload = {
        resolveTypes,
        amount,
        details,
        key: this.supportKey,
        keywords
      }
      return this.$store.dispatch('resolveSupport', payload)
        .then(() => {
          this.$emit('resolved')
        })
        .catch(err => {
          console.error(err)
          this.$store.dispatch('showToast', { info: err.message, level: 'error' })
          throw err
        })
    }
  },
  props: {
    value: Boolean,
    supportKey: String,
    defaultAmount: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SupportResolvePopup.vue